import { useState } from 'react';
import { t } from '../i18n';

const API_BASE = '/api/merchants';

function getAuthToken() {
  return localStorage.getItem('token') || '';
}

const colors = {
  bg: '#F7F5F0',
  surface: '#fff',
  border: '#E3E1D9',
  text: '#1F1E1B',
  textMuted: '#5F5E5A',
  primary: '#0F6E56',
  danger: '#A32D2D',
};

const CATEGORIES = [
  ['food', 'Food & Restaurant'],
  ['retail', 'Retail & Shopping'],
  ['services', 'Services'],
  ['health', 'Health & Beauty'],
  ['tech', 'Technology'],
  ['education', 'Education'],
  ['travel', 'Travel & Tourism'],
  ['other', 'Other'],
];

export default function MerchantRegister() {
  const [form, setForm] = useState({
    business_name: '', owner_name: '', designation: '', tagline: '', description: '', category: 'other',
    city: '', country: '', phone: '', email: '', website: '', facebook: '', instagram: '', linkedin: '', youtube: '', pi_username: '', pi_discount: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async () => {
    if (!getAuthToken()) {
      setError(t('mr_login'));
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/register/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${getAuthToken()}` },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Could not submit application.');
      setDone(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  const inputStyle = { width: '100%', padding: '10px 12px', fontSize: 14, border: '0.5px solid #B4B2A9', borderRadius: 6, boxSizing: 'border-box' };
  const labelStyle = { fontSize: 13, color: colors.textMuted, display: 'block', marginBottom: 4 };

  if (done) {
    return (
      <div style={{ maxWidth: 500, margin: '0 auto', padding: '3rem 1.5rem', textAlign: 'center', background: colors.bg, minHeight: '100vh', fontFamily: 'sans-serif' }}>
        <p style={{ fontSize: 40, margin: '0 0 12px' }}>✅</p>
        <h2 style={{ fontSize: 20, margin: '0 0 8px' }}>{t('mr_submitted')}</h2>
        <p style={{ fontSize: 14, color: colors.textMuted }}>
          An admin will review your business and approve it soon. You'll be able to add products
          from the Marketplace once approved.
        </p>
        <a href="/shopping" style={{ display: 'inline-block', marginTop: 16, color: colors.primary, fontSize: 14, fontWeight: 500 }}>← {t('mr_back')}</a>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 500, margin: '0 auto', padding: '1.5rem', background: colors.bg, minHeight: '100vh', fontFamily: 'sans-serif' }}>
      <h1 style={{ fontSize: 20, margin: '0 0 4px' }}>🏪 {t('mr_title')}</h1>
      <p style={{ fontSize: 13, color: colors.textMuted, margin: '0 0 1.5rem' }}>
        Register your business to start selling products for Pi.
      </p>

      <div style={{ display: 'grid', gap: 12, marginBottom: 16 }}>
        <div>
          <label style={labelStyle}>{t('mr_bname')}</label>
          <input style={inputStyle} value={form.business_name} onChange={update('business_name')} placeholder="XpertCreation Store" />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_tagline')}</label>
          <input style={inputStyle} value={form.tagline} onChange={update('tagline')} placeholder="Quality goods, powered by Pi" />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={labelStyle}>{t('mr_owner')}</label>
          <input style={inputStyle} value={form.owner_name} onChange={update('owner_name')} placeholder="Khalid Mahmood" />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={labelStyle}>{t('mr_desig')}</label>
          <input style={inputStyle} value={form.designation} onChange={update('designation')} placeholder="CEO / Owner / Manager" />
        </div>
        <div style={{ marginBottom: 12 }}>
        </div>
        <div>
          <label style={labelStyle}>{t('mr_desc')}</label>
          <textarea style={{ ...inputStyle, resize: 'vertical' }} rows={3} value={form.description} onChange={update('description')} />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_cat')}</label>
          <select style={inputStyle} value={form.category} onChange={update('category')}>
            {CATEGORIES.map(([val, label]) => (
              <option key={val} value={val}>{label}</option>
            ))}
          </select>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div>
            <label style={labelStyle}>{t('mr_city')}</label>
            <input style={inputStyle} value={form.city} onChange={update('city')} placeholder="Lahore" />
          </div>
          <div>
            <label style={labelStyle}>{t('mr_country')}</label>
            <input style={inputStyle} value={form.country} onChange={update('country')} placeholder="Pakistan" />
          </div>
        </div>
        <div>
          <label style={labelStyle}>{t('mr_phone')}</label>
          <input style={inputStyle} value={form.phone} onChange={update('phone')} placeholder="+92 3xx xxxxxxx" />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_email')}</label>
          <input style={inputStyle} type="email" value={form.email} onChange={update('email')} placeholder="store@example.com" />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_web')}</label>
          <input style={inputStyle} value={form.website} onChange={update('website')} placeholder="https://..." />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_fb')}</label>
          <input style={inputStyle} value={form.facebook} onChange={update('facebook')} placeholder="https://facebook.com/yourpage" />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_ig')}</label>
          <input style={inputStyle} value={form.instagram} onChange={update('instagram')} placeholder="https://instagram.com/yourpage" />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_li')}</label>
          <input style={inputStyle} value={form.linkedin} onChange={update('linkedin')} placeholder="https://linkedin.com/company/yourpage" />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_yt')}</label>
          <input style={inputStyle} value={form.youtube} onChange={update('youtube')} placeholder="https://youtube.com/@yourchannel" />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_piuser')}</label>
          <input style={inputStyle} value={form.pi_username} onChange={update('pi_username')} placeholder="@yourpiusername" />
        </div>
        <div>
          <label style={labelStyle}>{t('mr_disc')}</label>
          <input style={inputStyle} type="number" step="0.1" value={form.pi_discount} onChange={update('pi_discount')} placeholder="e.g. 5" />
          <p style={{ fontSize: 11, color: colors.textMuted, margin: '4px 0 0' }}>
            Applied automatically to every product in your store at checkout - e.g. "5" means every
            buyer gets 5% off, on top of any voucher codes they use.
          </p>
        </div>
      </div>

      {error && <p style={{ fontSize: 13, color: colors.danger, marginBottom: 12 }}>{error}</p>}

      <button
        onClick={submit}
        disabled={submitting || !form.business_name}
        style={{ width: '100%', padding: '12px', fontSize: 14, fontWeight: 500, border: 'none', borderRadius: 8, background: colors.primary, color: '#fff', cursor: 'pointer' }}
      >
        {submitting ? t('mr_submitting') : t('mr_submit')}
      </button>
    </div>
  );
}
